/* eslint-disable */
/**
 * H5 页面用来判断当初所处的容器环境
 */
const agent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

const host = window.location.host || ''
const isUat = host.includes('uat')

export {
  agent,
  isUat
}
